import { Modal } from "antd";
import {
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

interface FaqModalType {
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
}

const FaqModal = ({ isModalOpen, setIsModalOpen }: FaqModalType) => {
  const toggleTawkChat = () => {
    if (window?.Tawk_API) {
      if (!window?.Tawk_API?.isChatMaximized()) {
        window?.Tawk_API?.maximize();
      } else {
        window?.Tawk_API?.minimize();
      }
      setIsModalOpen(false);
    }
  };
  const FaqContent = [
    {
      heading: "Live Chat",
      description: "Status: Available",
      icon: <MessageOutlined />,
      action: {
        type: "link",
        label: "Click here",
        url: null,
        clickAction: toggleTawkChat,
      },
    },
    {
      heading: "Email us",
      description: "We will reply in one business day",
      icon: <MailOutlined />,
      action: {
        type: "email",
        label: "support@avitechng.com",
        url: "mailto:support@avitechng.com",
      },
    },
    {
      heading: "Call us",
      description: "Speak with a representative",
      icon: <PhoneOutlined />,
      action: {
        type: "phone",
        label: "+234 704 627 0753",
        url: "tel:+2347046270753",
      },
    },
    {
      heading: "WhatsApp",
      description: "Chat with a representative",
      icon: <WhatsAppOutlined />,
      action: {
        type: "phone",
        label: "+234 704 627 0754",
        url: "https://wa.me/2347046270754",
      },
    },
  ];

  return (
    <Modal
      wrapClassName="request-page-modal"
      title={"Talk to support"}
      open={isModalOpen}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
      footer={() => <div className=""></div>}
      width={"700px"}>
      <div className="font-UncutSansVariable grid grid-cols-2 mt-[40px] gap-4">
        {FaqContent?.map((content, id) => (
          <div key={id} className="border border-[#E7E7E7] p-4 rounded-2xl flex gap-5">
            <div className=" pt-[3px]">{content?.icon}</div>
            <div>
              <p className="text-[#0D0D0D] text-lg font-medium">
                {content?.heading}
              </p>
              <p className={`text-[#0D0D0D99] mt-0 text-sm`}>
                {content?.heading === "Live Chat" ? (
                  <span>
                    Status: <span className="text-primary">Available</span>
                  </span>
                ) : (
                  content?.description
                )}
              </p>
              <p className="mt-[20px] underline text-sm cursor-pointer hover:text-primary transition-all duration-300 ease-in w-fit">
                {content.action.url ? (
                  <a
                    className="text-[#0D0D0D]"
                    href={content.action.url}
                    target="_blank"
                    rel="noopener noreferrer">
                    {content?.action?.label}
                  </a>
                ) : (
                  <span onClick={content.action.clickAction}>
                    {content?.action?.label}
                  </span>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default FaqModal;
